import Component from 'component';
import datepicker from 'js-datepicker'

class KitchenRemodelingGuideForm extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $form: this.$el.find('.krg-form__form'),
      $success: this.$el.find('.krg-form__success')
    };

    const picker = datepicker('.js-datepicker', {
      formatter: (input, date, instance) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        input.value = `${month}/${day}/${year}`;
      }
    });
  }

  addListeners() {
    this.dom.$form.on('submit', ::this.onFormSubmit);
  }

  onFormSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    const self = this;

    if (this.dom.$form.valid()) {
      const quoteAdditionalAreas = $('.callout-field__field-checkboxes.areas-to-quote input[type=checkbox]:checked').map(function() {
        return this.value;
      }).get().join(';');

      $.ajax({
        type: $(self.dom.$form).attr('method'),
        url: $(self.dom.$form).attr('action'),
        data: `${$(self.dom.$form).serialize()}&QuoteAdditionalAreas=${quoteAdditionalAreas}`,
        success() {
          self.dom.$form.attr('hidden', '');
          self.dom.$success.removeAttr('hidden');
        },
        error(err) {
          console.error(err);
        }
      });
    }
  }
}

export default KitchenRemodelingGuideForm;



// WEBPACK FOOTER //
// ./src/ktu/js/components/KitchenRemodelingGuideForm.js